import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { token, initialized } = useAuth();
  const location = useLocation();

  if (!initialized) return <div>Loading...</div>;

  if (!token) {
    // Pass the current location so login can redirect back
    return <Navigate to={`/login?from=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
